export default __webpack_public_path__ + "static/naves_3-51e4c06d2762a4183f67c98995880548.jpg";